import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}

const TooltipInfoRow = ({ label }: Props) => {
  return (
    <Box flexDirection="row" textAlign="left">
      <Text size="200" color="lighter920">
        {label}
      </Text>
    </Box>
  )
}

export default TooltipInfoRow
